module.exports = __webpack_public_path__ + "static/media/play_solid.d6b3676a.svg";